module.exports = __webpack_public_path__ + "img/8352237.jpg";